export type SubscriptionTier = 'FREE' | 'PRO' | 'MAX'

export interface ModelOption {
  id: string
  displayName: string
  requiredTier: SubscriptionTier
}

const TIER_RANK: Record<SubscriptionTier, number> = { FREE: 0, PRO: 1, MAX: 2 }

export const MODEL_OPTIONS: ModelOption[] = [
  { id: 'claude-haiku', displayName: 'Claude Haiku (Fast)', requiredTier: 'FREE' },
  { id: 'claude-sonnet', displayName: 'Claude Sonnet (Smart)', requiredTier: 'PRO' },
  { id: 'gpt-4o-mini', displayName: 'GPT-4o Mini', requiredTier: 'FREE' },
  { id: 'gpt-4o', displayName: 'GPT-4o', requiredTier: 'PRO' },
]

export const DEFAULT_MODEL_BY_TIER: Record<SubscriptionTier, string> = {
  FREE: 'claude-haiku',
  PRO: 'claude-sonnet',
  MAX: 'claude-sonnet',
}

export function filterModelsByTier(tier: SubscriptionTier): ModelOption[] {
  return MODEL_OPTIONS.filter((m) => TIER_RANK[tier] >= TIER_RANK[m.requiredTier])
}
